import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initSilAssumptionState: types.SilAssumptionState = {
    baseRoute: null,
    reloadView: true,
}

const silAssumptionReducer = produce((
    draft: types.SilAssumptionState = initSilAssumptionState,
    action: ActionTypes = null,
): types.SilAssumptionState => {
    switch (action.type) {
        case types.SIL_ASSUMPTION_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.SIL_ASSUMPTION_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        default:
            return draft
    }
})
export default silAssumptionReducer
